import request from '@utils/request';

const PREFIX = '[CASE PREVIEW]';

export const GET_CASE_PREVIEW_REQUEST = `${PREFIX} GET_CASE_PREVIEW_REQUEST`;
export const GET_CASE_PREVIEW_SUCCESS = `${PREFIX} GET_CASE_PREVIEW_SUCCESS`;
export const GET_CASE_PREVIEW_FAILURE = `${PREFIX} GET_CASE_PREVIEW_FAILURE`;

const getCasePreviewRequest = () => ({
  type: GET_CASE_PREVIEW_REQUEST,
});

const getCasePreviewSuccess = payload => ({
  type: GET_CASE_PREVIEW_SUCCESS,
  payload,
});

const getCasePreviewFailure = () => ({
  type: GET_CASE_PREVIEW_FAILURE,
});

export const getCasePreview = () => (dispatch) => {
  dispatch(getCasePreviewRequest());

  return request
    .get('v1/cases/preview')
    .then(({ data }) => dispatch(getCasePreviewSuccess(data)))
    .catch((error) => {
      dispatch(getCasePreviewFailure());

      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/casePreview.js